import React, { useState, useEffect } from 'react';
import { notification, Badge, Button, Card, Typography, Timeline, Avatar } from 'antd';
import { BellOutlined, MessageOutlined, UserOutlined, CloseOutlined } from '@ant-design/icons';
import websocketService from '../services/websocket';

const { Text, Title } = Typography;

const WebSocketNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [messages, setMessages] = useState([]);
  const [userEvents, setUserEvents] = useState([]);
  const [breakEvents, setBreakEvents] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [showPanel, setShowPanel] = useState(false);

  // MOCK DATA: set notifications/messages ทันทีที่ mount
  useEffect(() => {
    setNotifications([
      {
        id: 1,
        title: 'แจ้งเตือน',
        message: 'Deposit: ไม่มีพนักงานในกะนี้',
        type: 'warning',
        timestamp: new Date(),
      },
      {
        id: 2,
        title: 'แจ้งเตือน',
        message: 'Withdraw: มีเคสค้างเกิน 5 นาที 2 รายการ',
        type: 'danger',
        timestamp: new Date(),
      },
      {
        id: 3,
        title: 'แจ้งเตือน',
        message: 'ETC: มีเคสใหม่เข้ามา',
        type: 'info',
        timestamp: new Date(),
      },
    ]);
    setMessages([
      {
        id: 1,
        message: 'Withdraw: มีเคสใหม่เข้ามา',
        username: 'ระบบ',
        userId: 0,
        timestamp: new Date(),
      },
      {
        id: 2,
        message: 'Deposit: พนักงานทั้งหมดออกจากระบบ',
        username: 'ระบบ',
        userId: 0,
        timestamp: new Date(),
      },
      {
        id: 3,
        message: 'ETC: ตรวจสอบข้อมูลด่วน',
        username: 'หัวหน้า',
        userId: 0,
        timestamp: new Date(),
      },
    ]);
    setIsConnected(true); // mock ว่าเชื่อมต่อเสมอ
  }, []);

  const NotificationIcon = () => (
    <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setShowPanel(!showPanel)}>
      <BellOutlined style={{ fontSize: '18px', color: isConnected ? '#52c41a' : '#ff4d4f' }} />
      {(notifications.length > 0 || messages.length > 0 || breakEvents.length > 0) && (
        <Badge 
          count={notifications.length + messages.length + breakEvents.length} 
          size="small" 
          style={{ position: 'absolute', top: -8, right: -8 }}
        />
      )}
      <div style={{
        position: 'absolute',
        bottom: -4,
        right: -4,
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: isConnected ? '#52c41a' : '#ff4d4f',
        border: '1px solid white'
      }} />
    </div>
  );

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('th-TH', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <>
      <NotificationIcon />
      
      {showPanel && (
        <div style={{
          position: 'fixed',
          top: 60,
          right: 20,
          width: 350,
          maxHeight: 500,
          backgroundColor: 'white',
          borderRadius: 8,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 1000,
          overflow: 'hidden'
        }}>
          <div style={{
            padding: '12px 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#fafafa'
          }}>
            <Title level={5} style={{ margin: 0 }}>
              แจ้งเตือน & ข้อความ
            </Title>
            <Button 
              type="text" 
              size="small" 
              icon={<CloseOutlined />} 
              onClick={() => setShowPanel(false)}
            />
          </div>

          <div style={{ maxHeight: 400, overflowY: 'auto', padding: 8 }}>
            {/* สถานะการเชื่อมต่อ */}
            {/* <div style={{ 
              padding: 8, 
              backgroundColor: isConnected ? '#f6ffed' : '#fff2f0',
              borderRadius: 4,
              marginBottom: 8,
              border: `1px solid ${isConnected ? '#b7eb8f' : '#ffccc7'}`
            }}>
              <Text style={{ 
                fontSize: 12, 
                color: isConnected ? '#52c41a' : '#ff4d4f'
              }}>
                {isConnected ? '🟢 เชื่อมต่อแล้ว' : '🔴 ไม่ได้เชื่อมต่อ'}
              </Text>
            </div> */}

            {/* Notifications */}
            {notifications.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 14, color: '#1890ff' }}>📢 การแจ้งเตือน</Text>
                {notifications.slice(0, 5).map(notif => (
                  <div key={notif.id} style={{
                    padding: 8,
                    margin: '4px 0',
                    backgroundColor: '#f9f9f9',
                    borderRadius: 4,
                    borderLeft: `3px solid ${
                      notif.type === 'success' ? '#52c41a' :
                      notif.type === 'warning' ? '#faad14' :
                      notif.type === 'error' ? '#ff4d4f' : '#1890ff'
                    }`
                  }}>
                    <div style={{ fontWeight: 500, fontSize: 13 }}>{notif.title}</div>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{notif.message}</div>
                    <div style={{ fontSize: 10, color: '#999', marginTop: 4 }}>
                      {formatTime(notif.timestamp)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Messages */}
            {/* {messages.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 14, color: '#52c41a' }}>💬 ข้อความ</Text>
                {messages.slice(0, 5).map(msg => (
                  <div key={msg.id} style={{
                    padding: 8,
                    margin: '4px 0',
                    backgroundColor: '#f0f9ff',
                    borderRadius: 4,
                    borderLeft: '3px solid #1890ff'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <Avatar size={16} icon={<UserOutlined />} />
                      <Text strong style={{ fontSize: 12 }}>{msg.username}</Text>
                      <Text style={{ fontSize: 10, color: '#999' }}>
                        {formatTime(msg.timestamp)}
                      </Text>
                    </div>
                    <div style={{ fontSize: 12, marginTop: 4, paddingLeft: 22 }}>
                      {msg.message}
                    </div>
                  </div>
                ))}
              </div>
            )} */}

            {/* User Events */}
            {userEvents.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ fontSize: 14, color: '#722ed1' }}>👥 กิจกรรมผู้ใช้</Text>
                {userEvents.slice(0, 3).map(event => (
                  <div key={event.id} style={{
                    padding: 6,
                    margin: '4px 0',
                    backgroundColor: '#f9f0ff',
                    borderRadius: 4,
                    borderLeft: '3px solid #722ed1'
                  }}>
                    <Text style={{ fontSize: 12 }}>{event.message}</Text>
                    <div style={{ fontSize: 10, color: '#999' }}>
                      {formatTime(event.timestamp)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Break Events */}
            {breakEvents.length > 0 && (
              <div>
                <Text strong style={{ fontSize: 14, color: '#fa8c16' }}>🍽️ สถานะการพัก</Text>
                {breakEvents.slice(0, 3).map(event => (
                  <div key={event.id} style={{
                    padding: 6,
                    margin: '4px 0',
                    backgroundColor: '#fff7e6',
                    borderRadius: 4,
                    borderLeft: '3px solid #fa8c16'
                  }}>
                    <Text style={{ fontSize: 12 }}>{event.message}</Text>
                    <div style={{ fontSize: 10, color: '#999' }}>
                      {formatTime(event.timestamp)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {notifications.length === 0 && messages.length === 0 && userEvents.length === 0 && breakEvents.length === 0 && (
              <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>
                <Text>ไม่มีแจ้งเตือนใหม่</Text>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default WebSocketNotification; 